<script setup lang="ts">
/** [#e03fdbc2] Политика конфиденциальности: русский, узбекский, английский. Испанская страница показывает английский текст. */
import { computed } from 'vue';
import { ChevronRight, Info } from 'lucide-vue-next';
import privacy from '@/content/privacy.json';
import PublicShell from './landing/PublicShell.vue';
import { usePublicPage } from './landing/usePublicPage';

const { locale, copy, more, to } = usePublicPage();
const hasOwnText = computed(() => locale.value in privacy);
const doc = computed(() => privacy[(hasOwnText.value ? locale.value : 'en') as keyof typeof privacy]);
</script>

<template>
  <PublicShell>
    <main>
      <div class="lp-wrap lp-page lp-contract-top">
        <nav class="lp-crumbs" :aria-label="copy.articles.home">
          <RouterLink :to="to('/')">{{ copy.articles.home }}</RouterLink>
          <ChevronRight :size="14" /><span>{{ more.privacy.title }}</span>
        </nav>
        <header class="lp-page-head">
          <h1>{{ more.privacy.title }}</h1>
          <p>{{ doc.updated }}</p>
        </header>
        <p v-if="!hasOwnText" class="lp-limit lp-contract-note"><Info :size="16" />{{ more.privacy.onlyEn }}</p>
      </div>
      <div class="lp-wrap lp-privacy">
        <article class="lp-card lp-doc" :lang="hasOwnText ? locale : 'en'">
          <p>{{ doc.intro }}</p>
          <section v-for="(s, i) in doc.sections" :id="`p${i + 1}`" :key="s.title">
            <h2>{{ i + 1 }}. {{ s.title }}</h2>
            <p v-for="(para, j) in s.paras" :key="j">{{ para }}</p>
            <ul v-if="s.list.length"><li v-for="li in s.list" :key="li">{{ li }}</li></ul>
          </section>
        </article>
      </div>
    </main>
  </PublicShell>
</template>
